/* eslint-disable no-useless-concat */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */



//suggest improvements for this component
// ran this thru claudes code refactoring tool


// Cards / product tiles — add "use card pattern: white bg, rounded-2xl, shadow-sm, hover:shadow-md hover:scale-[1.02] transition-all"
// Modals / drawers — add "use frosted glass: bg-white/95 backdrop-blur-sm, rounded-3xl, shadow-2xl"
// Forms / inputs — add "inputs should be rounded-2xl, border with primaryColor+'30', focus ring using primaryColor+'40'"
// Tables / lists — add "rows use hover:bg-primaryColor+'08', active row uses primaryColor+'12' background"
// Toasts / alerts — add "rounded-2xl, shadow-md, soft tinted background matching severity (rose for error, emerald for success)"
// The most important line to always include is:

// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."

// ─── ProductCard (Elegant Redesign) ─────────────────────────────────────────
// Fonts: add to your index.html <head>:
// <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600&family=DM+Sans:wght@400;500&display=swap" rel="stylesheet" />

// make the product cards look elegant and polished with a lttle more pizzaz
// do not change any functionality

// redesign this component to look more elegant and polished
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task

// give me the entire code to copy any insrtuctions to implement

// redesign just improve the product cards to add a little more pizzaz
// do not change any functionality
// use tailwind css in the className directive 
// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.

// ask me a series of questions to gather additional context you need to best achive this task
// Give me the complete code with instructions


import React, { useEffect, useState, lazy, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { FaEye, FaHeart } from "react-icons/fa";
import { MdOutlineRestaurantMenu, MdVerticalAlignTop } from "react-icons/md";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { FaUser } from "react-icons/fa6";

import { add_to_cart, add_to_wishlist, messageClear } from '../../store/reducers/cartReducer';
import Modal2 from '../Modal2';

import toast from 'react-hot-toast';
import { currencyFormat } from '../CurrencyFormat';
import SkeletonWithImage from '../SkeletonWithImage';

const Rating = lazy(() => import('../Rating'));

// ─── ProductCard ─────────────────────────────────────────────────────────────

const ProductCard = React.memo(({ product: p, styles, sellerConfig, sellerColorSuffixDark, sellerColorSuffixMedium, 
    sellerColorSuffixLight, onAddToCart, onAddToWishlist, onChat, onQuickView, showAllProductsButton, showScrollToTopButton }) => {
    const [portionSize, setPortionSize] = useState('');
    const navigate = useNavigate();
    const { userInfo } = useSelector(state => state.auth);

    const {
        primaryColor,
        secondaryColor,
        shoppingTerm,
        showPayments,
        showWishlist,
        showRating,
        showChat,
    } = sellerConfig;

    const portionSizeOptions = p.portionSizes
        ? p.portionSizes.split(';').filter(Boolean)
        : [];

    const handleAddToCart    = () => onAddToCart(p._id, portionSize);
    const handleAddToWishlist = () => onAddToWishlist(p);
    const handleChat          = () => onChat(p.name);
    const handleQuickView     = () => onQuickView(p);
    const handleViewDetails   = () => navigate(`/product/details/${p._id}`);
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // ── Overlay action icon ──────────────────────────────────────────────────

    const OverlayIcon = ({ onClick, hidden, icon, label }) => {
        if (hidden) return null;

        return (
            <button
                type="button"
                onClick={onClick}
                aria-label={label}
                className="relative w-9 h-9 rounded-full flex items-center justify-center
                    bg-white/95 backdrop-blur-sm border text-sm shadow-md cursor-pointer
                    transition-all duration-200 hover:scale-110 group/icon"
                style={{ 
                    color: primaryColor + sellerColorSuffixDark, 
                    borderColor: primaryColor + sellerColorSuffixDark, 
                    //backgroundColor: secondaryColor + sellerColorSuffixDark
                }}>
                {/* Icon group-hover/icon:rotate-[360deg]  hover:scale-110*/}
                <span className="flex items-center justify-center
                    transition-transform duration-500
                    group-hover/icon:rotate-[360deg]">
                    {icon}
                </span>

                {/* Tooltip */}
                <span
                    className="absolute bottom-[110%] left-1/2 -translate-x-1/2
                        text-white text-[11px] font-medium leading-tight text-center
                        px-2 py-1 rounded-md whitespace-nowrap pointer-events-none
                        opacity-0 scale-90 border-2 border-white
                        group-hover/icon:opacity-100 group-hover/icon:scale-100
                        transition-all duration-200"
                    style={{ backgroundColor: primaryColor + sellerColorSuffixDark }}>
                    {label.split('~').map((word, i, arr) => (
                        <React.Fragment key={i}>
                            {word}
                            {i < arr.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                    {/* Triangle arrow also in tooltip.css */}
                    <span
                        className="absolute -bottom-6 left-1/2 -translate-x-1/2
                            border-[11px] border-transparent border-t-orange-400"
                    />
                </span>
            </button>
        );
    };

    // ── Portion size selector ────────────────────────────────────────────────
    const PortionSizeSelect = () =>
        portionSizeOptions.length > 0 ? (
            <select
                value={portionSize}
                onChange={e => setPortionSize(e.target.value)}
                className="w-full rounded-full border px-3 py-1.5 text-[13px] 
                    font-medium focus:outline-none cursor-pointer"
                style={{ 
                    borderColor: primaryColor + sellerColorSuffixDark, 
                    color: primaryColor + sellerColorSuffixDark, 
                    backgroundColor: primaryColor + sellerColorSuffixLight
                }}>
                <option value="">Choose Portion Size</option>
                {portionSizeOptions.map((size, i) => (
                    <option key={i} value={size}>{size}</option>
                ))}
            </select>
        ) : null;

    // ── Primary CTA button ───────────────────────────────────────────────────
    const CartButton = ({ small = false }) => (
        <div>
            <button
                type="button"
                onClick={handleAddToCart}
                className={`w-full rounded-full font-semibold tracking-widest uppercase
                    transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]
                    flex items-center justify-center gap-1.5 text-white
                    shadow-sm hover:shadow-md border-2
                    ${small ? 'py-[4px] text-[13px]' : 'py-[7px] text-[13px]'}`}
                style={{ 
                    backgroundColor: primaryColor + sellerColorSuffixDark, 
                    borderColor: primaryColor + sellerColorSuffixDark 
                }}>
                {userInfo
                    ? <><MdOutlineRestaurantMenu size={18} /> Add To {shoppingTerm}</>
                    : <><FaUser size={16} /> Please Login</>}
            </button>
            
            <Link 
                type="button"
                to='/shops'
                className={` ${styles === 'grid' && showAllProductsButton  ? '' : 'hidden'} 
                    w-full rounded-full font-semibold tracking-widest uppercase
                    transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]
                    flex items-center justify-center gap-1.5 text-white
                    shadow-sm hover:shadow-md mt-1.5 border 
                    py-[7px] text-[13px]`}
                style={{ 
                    borderColor: primaryColor + sellerColorSuffixMedium, 
                    color: primaryColor + sellerColorSuffixDark, 
                    backgroundColor: primaryColor + sellerColorSuffixLight
                }}>
                <MdOutlineRestaurantMenu size={20} style={{ color: primaryColor + sellerColorSuffixDark }} /> Explore  All {sellerConfig.productPluralTerm}
            </Link>
        </div>
    );

    // ────────────────────────────────────────────────────────────────────────
    // GRID CARD  — Upscale / Fine dining, Subtle polish
    // ────────────────────────────────────────────────────────────────────────
    if (styles === 'grid') {
        return (
            <div
                className="group flex flex-col bg-white overflow-hidden
                    transition-shadow duration-500
                    hover:shadow-[0_24px_56px_rgba(0,0,0,0.13)]"
                style={{
                    borderRadius: '8px',
                    border: `2px solid ${primaryColor}${sellerColorSuffixMedium}`,
                    //boxShadow: `0 4px 20px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.9)`,
                }}>
                {/* ── Accent top stripe 3px 
                anchor for my custom menu id={p?.name.replaceAll(' ', '_')}
                 ──────────────────────────────── */}
                <div className="h-[8px] w-full flex-shrink-0" id={p?.name.replaceAll(' ', '_')}
                    style={{
                        background: `linear-gradient(90deg, ${primaryColor}${sellerColorSuffixMedium} 0%, ${primaryColor} 50%, ${primaryColor}${sellerColorSuffixMedium} 100%)`,
                    }}
                />

                {/* ── Image area   ─────────────────────────────────────── */}
                {/*  this is for each seller if productImageWidth =400 and height =300 then show skeleton 
                    and image of those proportions and so on  
                    from components/CartProduct.jsx
                    Image — shrinks fluidly, never overflows 
                    Image — fixed size wrapper collapses the skeleton's internal height

                    <div className='shrink-0 overflow-hidden relative' 
                        style={{ width: 'clamp(80px, 20vw, 150px)', height: 'clamp(60px, 15vw, 110px)' }}>
                        <SkeletonWithImage
                            src={pt.productInfo.images[0]}
                            alt={pt.productInfo.name}
                            className='rounded object-cover'
                            style={{ width: 'clamp(80px, 20vw, 150px)', height: 'clamp(60px, 15vw, 110px)' }}
                        />
                */}
                
                <div 
                    className="relative h-[220px] md:h-[250px] xs:h-[200px] overflow-hidden"
                    style={{ background: primaryColor + sellerColorSuffixLight }}>
                    <SkeletonWithImage
                        src={p.images[0]}
                        alt={p.name}
                        className="w-full h-full transition-transform duration-700 group-hover:scale-[1.07] object-cover"
                    />

                    {/* Refined gradient scrim — visible always, deepens on hover */}
                    <div
                        className="absolute inset-0 transition-opacity duration-500"
                        style={{
                            background: 'linear-gradient(to top, rgba(0,0,0,0.42) 0%, rgba(0,0,0,0.10) 45%, transparent 100%)',
                            opacity: 0.7,
                        }} />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent
                        opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                    {/* byThePan badge */}
                    {p.byThePan !== 'NoPan' && (
                        <span
                            className="absolute top-0.5 right-0.5 text-[11px] font-semibold tracking-wide
                                uppercase px-1.5 py-0 rounded-lg text-white shadow-md backdrop-blur-sm"
                            style={{ backgroundColor: primaryColor + sellerColorSuffixDark, border: '1px solid white' }}>
                            {p.byThePan}
                        </span>
                    )}

                    {/* Price floated on image bottom-left — fine-dining menu style 
                    style={{ backgroundColor: 'rgba(0,0,0,0.45)', border: '1px solid rgba(255,255,255,0.18)' }}
                    */}
                    {showPayments && (
                        <span
                            className="absolute top-0.5 left-0.5 text-[11px] font-semibold tracking-wide
                                px-1.5 py-0 rounded-lg text-white backdrop-blur-sm shadow-sm"
                            style={{ backgroundColor: primaryColor + sellerColorSuffixDark, border: '1px solid white' }}>
                            {currencyFormat.format(p.price)}
                        </span>
                    )}

                    {/* Hover action icons */}
                    <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-2 pb-3
                            translate-y-4 opacity-0
                            group-hover:translate-y-0 group-hover:opacity-100
                            transition-all duration-300">
                        <OverlayIcon onClick={handleAddToCart}    icon={<MdOutlineRestaurantMenu size={22} />} label={`Add To~${shoppingTerm}`} />
                        <OverlayIcon onClick={handleAddToWishlist} hidden={!showWishlist} icon={<FaHeart size={18} />} label="Add To~My Wishlist" />
                        <OverlayIcon onClick={handleQuickView}    icon={<FaEye size={22} />} label="Quick~View" />
                        <OverlayIcon onClick={handleChat}         hidden={!showChat} icon={<IoChatbubbleEllipsesSharp size={20} />} label="Chat~With Us" />
                    </div>
                </div>

                {/* ── Info area ──────────────────────────────────────── */}
                <div className="flex flex-col gap-1.5 px-3 pt-3 pb-3 flex-1">
                    
                    {/* Thin divider accent 
                    background: `linear-gradient(90deg, ${primaryColor}88 0%, ${primaryColor} 50%, ${primaryColor}88 100%)`,
                    */}
                    <div
                        className="hidden w-full h-[1.5px] mb-1 rounded-full"
                        style={{ background: `linear-gradient(90deg, ${primaryColor}${sellerColorSuffixMedium}, ${primaryColor}${sellerColorSuffixMedium})` }}
                    />

                    <div className="flex items-center justify-between gap-1.5 border-none border-black px-0 py-1">
                        <div className="flex items-center gap-1 min-w-0">
                            <div
                                className="w-[4px] h-5 rounded-full flex-shrink-0"
                                style={{ backgroundColor: primaryColor + sellerColorSuffixMedium }}
                            />
                            <div
                                className="truncate font-semibold leading-snug tracking-wide text-[16px]"
                                style={{ color: primaryColor + sellerColorSuffixDark }}>
                                {p.name}
                            </div>
                        </div>
                        
                        <button
                            onClick={scrollToTop}
                            className={` ${showScrollToTopButton ? '' : 'hidden'} 
                                flex items-center flex-shrink-0 ml-1.5 px-1 rounded-md text-white 
                                text-[13px] font-semibold border`}
                            style={{ 
                                backgroundColor: primaryColor + sellerColorSuffixLight, 
                                color: primaryColor + sellerColorSuffixDark,
                                borderColor: primaryColor + sellerColorSuffixDark
                            }}> 
                            <MdVerticalAlignTop size={17} className="" /> Top
                        </button>
                    </div>

                    <div
                        className="hidden w-full h-[1.5px] mb-1 rounded-full"
                        style={{ background: `linear-gradient(90deg, ${primaryColor}${sellerColorSuffixMedium}, ${primaryColor}${sellerColorSuffixMedium})` }}
                    />

                    {/* Rating row — price now lives on image */}
                    {showRating && (
                        <div className="flex items-center gap-2">
                            <Rating ratings={p.rating} />
                        </div>
                    )}

                    {/* Description or portion select */}
                    {portionSizeOptions.length > 0
                        ? <PortionSizeSelect />
                        : (
                            <p
                                className="text-[12px] font-bold leading-relaxed line-clamp-2 m-0"
                                style={{ color: primaryColor + sellerColorSuffixMedium, letterSpacing: '0.01em' }}>
                                {p.description}
                            </p>
                        )
                    }

                    {/* CTA */}
                    <div className="mt-auto pt-0.5">
                        <CartButton />
                    </div>
                </div>
            </div>
        );
    }

    // ────────────────────────────────────────────────────────────────────────
    // LIST CARD  — Upscale / Fine dining, Subtle polish
    // ────────────────────────────────────────────────────────────────────────
    return (
        <div
            className="group flex flex-col bg-white overflow-hidden transition-all duration-500
                hover:-translate-y-1 hover:shadow-[0_20px_48px_rgba(0,0,0,0.11)]"
            style={{
                borderRadius: '8px',
                border: `2px solid ${primaryColor}${sellerColorSuffixMedium}`,
                boxShadow: `0 4px 20px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.9)`,
            }}>
            {/* ── Accent top stripe w-full ────────────────────────────────────── */}
            <div
                className="h-[8px] w-full flex-shrink-0"
                style={{
                    background: `linear-gradient(90deg, ${primaryColor}${sellerColorSuffixMedium} 0%, ${primaryColor} 50%, ${primaryColor}${sellerColorSuffixMedium} 100%)`,
                }}
            />

            {/* ── Row content ──────────────────────────────────────────── */}
            <div className="flex md-lg:flex-col flex-1 overflow-hidden">
            {/* ── Image area object-cover  ───────────────────────────────────────────── */}
                <div
                    className="relative flex-shrink-0 w-[240px] md-lg:w-full h-[220px] md:h-[220px] overflow-hidden">
                    {/* style={{ background: secondaryColor, borderRadius: '8px 0 0 8px' }}  */}
                    <SkeletonWithImage
                        src={p.images[0]}
                        alt={p.name}
                        className="w-full h-full transition-transform duration-700 group-hover:scale-[1.07]"
                    />

                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent
                    opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                    {p.byThePan !== 'NoPan' && (
                        <span
                            className="absolute top-3 left-3 text-[9px] font-semibold tracking-[0.18em]
                                uppercase px-3 py-[5px] rounded-full text-white shadow-md backdrop-blur-sm"
                            style={{ backgroundColor: primaryColor + sellerColorSuffixDark, border: '1px solid white' }}>
                            {p.byThePan}
                        </span>
                    )}
                </div>

                {/* ── Info area ────────────────────────────────────────────── */}
                <div className="flex flex-col gap-2 pl-7 pr-6 pt-2 pb-1.5 flex-1 relative">

                    {/* Thin horizontal divider accent */}
                    <div
                        className="hidden w-10 h-[1.5px] mb-0.5 rounded-full"
                        style={{ background: `linear-gradient(90deg, ${primaryColor}, ${primaryColor}${sellerColorSuffixMedium})` }}
                    />

                    {/* Name fontFamily: "'Cormorant Garamond', Georgia, serif", */}
                    <div className="flex items-center gap-1.5">
                        <div
                            className="w-[5px] h-6 rounded-full"
                            style={{ backgroundColor: primaryColor + sellerColorSuffixMedium }}
                            />
                        <div
                            className="text-[22px] font-semibold leading-tight m-0 tracking-wide"
                            style={{
                                color: primaryColor + sellerColorSuffixDark,
                                fontSize: '23px',
                            }}>
                            {p.name}
                        </div>
                    </div>
                    {/* Price + Rating */}
                    <div className="flex items-center gap-3">
                        {showPayments && (
                            <span
                                className="text-[14px] font-semibold border
                                    tracking-wide px-2 py-0.5 rounded-xl"
                                style={{
                                    color: primaryColor + sellerColorSuffixDark,
                                    backgroundColor: primaryColor + sellerColorSuffixLight,
                                    borderColor: primaryColor + sellerColorSuffixDark,
                                }}>
                                {currencyFormat.format(p.price)}
                            </span>
                        )}
                        {showRating && <Rating ratings={p.rating} />}
                    </div>

                    {/* Description line-clamp-3 overflow: 'hidden', */}
                    <div
                        className="text-sm leading-relaxed rounded-xl px-2 py-1.5 border-l-4 whitespace-pre-wrap transition-all duration-300 relative"
                        style={{
                            color: primaryColor + sellerColorSuffixDark,
                            borderLeftColor: primaryColor + sellerColorSuffixMedium,
                            backgroundColor: primaryColor + sellerColorSuffixLight,
                        }}>
                        <div
                            className={` ${showPayments || showRating ? 'h-[42px]' : 'h-[70px]'}
                                overflow-y-auto text-[13px] leading-relaxed m-0 p-0.5 font-bold border-none border-black`}
                            style={{
                                color: primaryColor + sellerColorSuffixMedium,
                                borderColor: primaryColor + sellerColorSuffixMedium,
                                maxHeight: portionSizeOptions.length > 0 ? '3.5rem' : '5rem',
                                letterSpacing: '0.01em',
                            }}>
                            {p.description}
                        </div>
                    </div>
                    {/* Portion select */}
                    <PortionSizeSelect />

                    {/* Action buttons */}
                    <div className="grid grid-cols-2 sm:grid-cols-1 gap-1.5 mt-auto pt-0">
                        <CartButton small />

                        {showWishlist && (
                            <button
                                type="button"
                                onClick={handleAddToWishlist}
                                className="flex items-center justify-center gap-1.5 rounded-full py-[5px] text-[13px]
                                    font-semibold tracking-widest uppercase border-2 transition-all duration-200
                                    hover:scale-[1.02] active:scale-[0.98]"
                                style={{ 
                                    borderColor: primaryColor + sellerColorSuffixDark, 
                                    color: primaryColor + sellerColorSuffixDark,
                                    backgroundColor: primaryColor + sellerColorSuffixLight 
                                }}>
                                {userInfo
                                    ? <><FaHeart size={18} /> Wishlist</>
                                    : <><FaUser size={16} /> Login</>}
                            </button>
                        )}

                        <button
                            type="button"
                            onClick={handleViewDetails}
                            className="flex items-center justify-center gap-1.5 rounded-full py-[5px] text-[13px]
                                font-semibold tracking-widest uppercase border-2 transition-all duration-200
                                hover:scale-[1.02] active:scale-[0.98]"
                            style={{ 
                                borderColor: primaryColor + sellerColorSuffixDark, 
                                color: primaryColor + sellerColorSuffixDark,
                                backgroundColor: primaryColor + sellerColorSuffixLight 
                            }}>
                            <FaEye size={20} /> View Details
                        </button>

                        {showChat && (
                            <button
                                type="button"
                                onClick={handleChat}
                                className="flex items-center justify-center gap-1.5 rounded-full py-[5px] text-[13px]
                                    font-semibold tracking-widest uppercase border-2 transition-all duration-200
                                    hover:scale-[1.02] active:scale-[0.98]"
                                style={{ 
                                    borderColor: primaryColor + sellerColorSuffixDark, 
                                    color: primaryColor + sellerColorSuffixDark,
                                    backgroundColor: primaryColor + sellerColorSuffixLight 
                                }}>
                                <IoChatbubbleEllipsesSharp size={20} /> Chat With Us
                            </button>
                        )}
                    </div>
                </div>{/* end info area */}
            </div>{/* end row content */}
        </div>
    );
});

ProductCard.displayName = 'ProductCard';

// ─── ShopProductGridListView ──────────────────────────────────────────────────
// add  showAddToMenuButton, showAddToWishlistButton columunCount param
// default values
// styles = {},  products = [], showAllProductsButton = true 

const ShopProductGridListView = ({ styles, products, showAllProductsButton, showAddToMenuButton = true, 
    showAddToWishlistButton = true, showScrollToTopButton = false, columnCount = 3 }) => {
    const { userInfo }                    = useSelector(state => state.auth);
    const { errorMessage, successMessage } = useSelector(state => state.cart);
    const { seller }                      = useSelector(state => state.seller);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [modalProduct, setModalProduct] = useState(null);

    const sellerConfig = useMemo(() => ({
        id:                                 seller?._id,
        primaryColor:                       seller?.frontEndPrimaryColor1,
        secondaryColor:                     seller?.frontEndSecondaryColor1,
        sellerArrHexOpacityColorSuffixes:   seller?.hexOpacityColorSuffixes?.split(';') || [],
        shoppingTerm:                       seller?.shoppingTerm,
        productPluralTerm:                  seller?.productPluralTerm,
        showPayments:                       seller?.isVisibleSitePayments === 'Show',
        showWishlist:                       seller?.isVisibleSiteWishlist === 'Show',
        showRating:                         seller?.isVisibleSiteRating   === 'Show',
        showChat:                           seller?.isVisibleSiteChat     === 'Show',
        showCuisineType:                    seller?.isVisibleSiteCuisineType === 'Show',
    }), [seller]);

    const sellerColorSuffixDark = sellerConfig.sellerArrHexOpacityColorSuffixes[0] || 'FF';
    const sellerColorSuffixMedium = sellerConfig.sellerArrHexOpacityColorSuffixes[1] || '80';
    const sellerColorSuffixLight = sellerConfig.sellerArrHexOpacityColorSuffixes[2] || '1A';
    
    const handleAddToCart = (productId, portionSize) => {
        if (!userInfo) { navigate('/login'); return; }
        dispatch(add_to_cart({ userId: userInfo.id, quantity: 1, productId, portionSize }));
    };

    const handleAddToWishlist = (product) => {
        if (!userInfo) { navigate('/login'); return; }
        dispatch(add_to_wishlist({
            userId:       userInfo.id,
            productId:    product._id,
            name:         product.name,
            price:        product.price,
            image:        product.images[0],
            discount:     product.discount,
            rating:       product.rating,
            slug:         product.slug,
            portionSizes: product.portionSizes,
            description:  product.description,
            byThePan:     product.byThePan,
        }));
    };

    const handleChat = (chatTopic) => {
        if (!userInfo) { navigate('/login'); return; }
        navigate(`/customerDashboard/chat/${chatTopic}`);
    };

    useEffect(() => {
        if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
        if (errorMessage)   { toast.error(errorMessage);   dispatch(messageClear()); }
    }, [successMessage, errorMessage, dispatch]);
        
    const gridColsMap = {
        1: 'grid-cols-1', 2: 'grid-cols-2', 3: 'grid-cols-3', 
        4: 'grid-cols-4', 5: 'grid-cols-5', 6: 'grid-cols-6',
    };
    const colClass = gridColsMap[columnCount] ?? 'grid-cols-3';

    return (
        <div className={`w-full grid gap-4 ${
            styles === 'grid'
                //? 'grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1'
                ? `${colClass} md-lg:grid-cols-2 md:grid-cols-1`
                : 'grid-cols-1 md-lg:grid-cols-2 md:grid-cols-1'
            }`}>
            {products.map((p) => (
                <ProductCard
                    key={p._id}
                    product={p}
                    styles={styles}
                    sellerConfig={sellerConfig}
                    sellerColorSuffixDark={sellerColorSuffixDark}
                    sellerColorSuffixMedium={sellerColorSuffixMedium}
                    sellerColorSuffixLight={sellerColorSuffixLight}
                    onAddToCart={handleAddToCart}
                    onAddToWishlist={handleAddToWishlist}
                    onChat={handleChat}
                    onQuickView={setModalProduct}
                    showAllProductsButton={showAllProductsButton}
                    showScrollToTopButton={showScrollToTopButton}
                />
            ))}

            <Modal2
                isOpen={!!modalProduct}
                onClose={() => setModalProduct(null)}
                product={modalProduct}
            />
        </div>
    );
};

export default ShopProductGridListView;


// import React, { useEffect, useState, lazy, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaEye, FaHeart } from "react-icons/fa";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { FaUser } from "react-icons/fa6";
// import { add_to_cart, add_to_wishlist, messageClear } from '../../store/reducers/cartReducer';
// import Modal2 from '../Modal2';

// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';
// import SkeletonWithImage from '../SkeletonWithImage';

// const Rating = lazy(() => import('../Rating'));

// // ─── ProductCard ─────────────────────────────────────────────────────────────

// const ProductCard = React.memo(({ product: p, styles, sellerConfig, onAddToCart, onAddToWishlist, onChat, onQuickView }) => {
//     const [portionSize, setPortionSize] = useState('');
//     const navigate = useNavigate();
//     const { userInfo } = useSelector(state => state.auth);

//     const {
//         primaryColor,
//         secondaryColor,
//         shoppingTerm,
//         showPayments,
//         showWishlist,
//         showRating,
//         showChat,
//     } = sellerConfig;

//     const portionSizeOptions = p.portionSizes
//         ? p.portionSizes.split(';').filter(Boolean)
//         : [];

//     const handleAddToCart    = () => onAddToCart(p._id, portionSize);
//     const handleAddToWishlist = () => onAddToWishlist(p);
//     const handleChat          = () => onChat(p.name);
//     const handleQuickView     = () => onQuickView(p);
//     const handleViewDetails   = () => navigate(`/product/details/${p._id}`);

//     // ── Overlay action icon ──────────────────────────────────────────────────

//     const OverlayIcon = ({ onClick, hidden, icon, label }) => {
//         if (hidden) return null;

//         return (
//             <button
//                 type="button"
//                 onClick={onClick}
//                 aria-label={label}
//                 className="relative w-9 h-9 rounded-full flex items-center justify-center
//                         bg-white border text-sm shadow-sm cursor-pointer
//                         transition-all duration-200 hover:scale-110 group/icon"
//                 style={{ color: primaryColor, borderColor: primaryColor }}>
//                 {/* Icon */}
//                 <span className="flex items-center justify-center
//                     transition-transform duration-500
//                     group-hover/icon:rotate-[360deg]">
//                     {icon}
//                 </span>

//                 {/* Tooltip */}
//                 <span
//                     className="absolute bottom-[110%] left-1/2 -translate-x-1/2
//                             text-white text-[11px] font-medium leading-tight text-center
//                             px-2 py-1 rounded-md whitespace-nowrap pointer-events-none
//                             opacity-0 scale-90 border-2 border-white
//                             group-hover/icon:opacity-100 group-hover/icon:scale-100
//                             transition-all duration-200"
//                     style={{ backgroundColor: primaryColor }}
//                 >
//                     {label.split('~').map((word, i, arr) => (
//                         <React.Fragment key={i}>
//                             {word}
//                             {i < arr.length - 1 && <br />}
//                         </React.Fragment>
//                     ))}
//                     {/* Triangle arrow */}
//                     <span
//                         className="absolute -bottom-5 left-1/2 -translate-x-1/2
//                             border-[10px] border-transparent border-t-yellow-400"
                        
//                     />
//                 </span>
//             </button>
//         );
//     };

//     // ── Portion size selector ────────────────────────────────────────────────
//     const PortionSizeSelect = () =>
//         portionSizeOptions.length > 0 ? (
//             <select
//                 value={portionSize}
//                 onChange={e => setPortionSize(e.target.value)}
//                 className="w-full rounded-full border px-4 py-2 text-[13px] font-medium mb-2
//                            bg-[#faf8f5] focus:outline-none cursor-pointer"
//                 style={{ borderColor: primaryColor + '55', color: primaryColor }}
//             >
//                 <option value="">Choose Portion Size</option>
//                 {portionSizeOptions.map((size, i) => (
//                     <option key={i} value={size}>{size}</option>
//                 ))}
//             </select>
//         ) : null;

//     // ── Primary CTA button ───────────────────────────────────────────────────
//     const CartButton = ({ small = false }) => (
//         <button
//             type="button"
//             onClick={handleAddToCart}
//             className={`w-full rounded-full font-medium tracking-wide
//                         transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]
//                         flex items-center justify-center gap-1.5 text-white
//                         ${small ? 'py-[2px] text-[16px]' : 'py-[4px] text-[16px]'}`}
//             style={{ backgroundColor: primaryColor }}
//         >
//             {userInfo
//                 ? <><MdOutlineRestaurantMenu size={18} /> Add to {shoppingTerm}</>
//                 : <><FaUser size={16} /> Login to Order</>}
//         </button>
//     );

//     // ────────────────────────────────────────────────────────────────────────
//     // GRID CARD
//     // ────────────────────────────────────────────────────────────────────────
//     // className="bg-white rounded-2xl shadow-xl overflow-hidden"
//     //                     style={{ borderTop: `4px solid ${sellerPrimaryColor1}` }}
//     if (styles === 'grid') {
//         return (
//             <div
//                 className="group flex flex-col bg-white overflow-hidden
//                            transition-all duration-300
//                            hover:-translate-y-1.5 hover:shadow-[0_16px_40px_rgba(0,0,0,0.10)]"
//                 style={{
//                     borderRadius: '18px',
//                     border: `1px solid ${primaryColor}72`,
//                 }}
//             >
//                 {/* ── Image area ─────────────────────────────────────── */}
//                 <div className="relative h-[210px] md:h-[250px] xs:h-[170px] overflow-hidden"
//                      style={{ background: secondaryColor }}>

//                     <SkeletonWithImage
//                         src={p.images[0]}
//                         alt={p.name}
//                         className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.05]"
//                     />

//                     {/* gradient scrim */}
//                     <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent
//                                     opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

//                     {/* byThePan badge */}
//                     {p.byThePan !== 'NoPan' && (
//                         <span
//                             className="absolute top-3 left-3 text-[10px] font-medium tracking-widest
//                                        uppercase px-3 py-1 rounded-full text-white shadow-sm"
//                             style={{ backgroundColor: primaryColor }}
//                         >
//                             {p.byThePan}
//                         </span>
//                     )}

//                     {/* hover action icons */}
//                     <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-2 pb-3
//                             translate-y-4 opacity-0
//                             group-hover:translate-y-0 group-hover:opacity-100
//                             transition-all duration-300">
//                         <OverlayIcon onClick={handleAddToCart}    icon={<MdOutlineRestaurantMenu />} label={`Add To~${shoppingTerm}`} />
//                         <OverlayIcon onClick={handleAddToWishlist} hidden={!showWishlist} icon={<FaHeart />} label="Add To~My Wishlist" />
//                         <OverlayIcon onClick={handleQuickView}    icon={<FaEye />} label="Quick~View" />
//                         <OverlayIcon onClick={handleChat}         hidden={!showChat} icon={<IoChatbubbleEllipsesSharp />} label="Chat~With Us" />
//                     </div>
//                 </div>

//                 {/* ── Info area ──────────────────────────────────────── */}
//                 <div className="flex flex-col gap-1 px-4 py-3 flex-1">

//                     {/* Name fontFamily: "'Cormorant Garamond', serif", */}
//                     <h3
//                         className="truncate text-[16px] font-semibold leading-snug m-0"
//                         style={{
//                             color: primaryColor,
//                         }}
//                     >
//                         {p.name}
//                     </h3>

//                     {/* Price + rating fontFamily: "'Cormorant Garamond', serif",
//                                     */}
//                     <div className="flex items-center gap-3">
//                         {showPayments && (
//                             <span
//                                 className="text-[14px] font-semibold"
//                                 style={{
//                                     color: primaryColor,
//                                 }}
//                             >
//                                 {currencyFormat.format(p.price)}
//                             </span>
//                         )}
//                         {showRating && <Rating ratings={p.rating} />}
//                     </div>

//                     {/* Description or portion select */}
//                     {portionSizeOptions.length > 0
//                         ? <PortionSizeSelect />
//                         : (
//                             <p
//                                 className="text-[12px] leading-relaxed line-clamp-2 m-0"
//                                 style={{ color: primaryColor + 'aa' }}
//                             >
//                                 {p.description}
//                             </p>
//                         )
//                     }

//                     {/* CTA */}
//                     <div className="mt-auto pt-2">
//                         <CartButton />
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     // ────────────────────────────────────────────────────────────────────────
//     // LIST CARD
//     // ────────────────────────────────────────────────────────────────────────
//     return (
//         <div
//             className="group flex md-lg:flex-col bg-white overflow-hidden
//                        transition-all duration-300
//                        hover:shadow-[0_12px_32px_rgba(0,0,0,0.09)]"
//             style={{
//                 borderRadius: '18px',
//                 border: `1px solid ${primaryColor}72`,
//             }}
//         >
//             {/* ── Image area ───────────────────────────────────────────── */}
//             <div className="relative flex-shrink-0 w-[240px] md-lg:w-full h-[220px] md:h-[220px] overflow-hidden"
//                  style={{ background: secondaryColor }}>

//                 <SkeletonWithImage
//                     src={p.images[0]}
//                     alt={p.name}
//                     className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.05]"
//                 />

//                 <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent
//                                 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

//                 {p.byThePan !== 'NoPan' && (
//                     <span
//                         className="absolute top-3 left-3 text-[10px] font-medium tracking-widest
//                                    uppercase px-3 py-1 rounded-full text-white"
//                         style={{ backgroundColor: primaryColor }}
//                     >
//                         {p.byThePan}
//                     </span>
//                 )}
//             </div>

//             {/* ── Info area ────────────────────────────────────────────── */}
//             <div className="flex flex-col gap-1.5 pr-5 pl-5 pt-1 pb-1 flex-1 border-none border-black">

//                 {/* Name fontFamily: "'Cormorant Garamond', serif", */}
//                 <h3
//                     className="text-[22px] font-semibold leading-tight m-0 border-none border-black"
//                     style={{
//                         color: primaryColor,
//                     }}
//                 >
//                     {p.name}
//                 </h3>

//                 {/* Price + Rating fontFamily: "'Cormorant Garamond', serif",
//                                  */}
//                 <div className="flex items-center gap-3">
//                     {showPayments && (
//                         <span
//                             className="text-[19px] font-semibold"
//                             style={{
//                                 color: primaryColor,
//                             }}
//                         >
//                             {currencyFormat.format(p.price)}
//                         </span>
//                     )}
//                     {showRating && <Rating ratings={p.rating} />}
//                 </div>

//                 {/* Description */}
//                 <p
//                     className="text-[13px] leading-relaxed m-0 "
//                     style={{
//                         color: primaryColor + 'aa',
//                         maxHeight: portionSizeOptions.length > 0 ? '3.5rem' : '5rem',
//                         overflow: 'hidden',
//                     }}
//                 >
//                     {p.description}
//                 </p>

//                 {/* Portion select */}
//                 <PortionSizeSelect />

//                 {/* Action buttons */}
//                 <div className="grid grid-cols-2 sm:grid-cols-1 gap-1.5 mt-auto pt-1">
//                     <CartButton small />

//                     {showWishlist && (
//                         <button
//                             type="button"
//                             onClick={handleAddToWishlist}
//                             className="flex items-center justify-center gap-1.5 rounded-full py-[4px] text-[16px]
//                                        font-medium border transition-all duration-200
//                                        hover:scale-[1.02] active:scale-[0.98]"
//                             style={{ borderColor: primaryColor, color: primaryColor }}
//                         >
//                             {userInfo
//                                 ? <><FaHeart size={18} /> Wishlist</>
//                                 : <><FaUser size={16} /> Login</>}
//                         </button>
//                     )}

//                     <button
//                         type="button"
//                         onClick={handleViewDetails}
//                         className="flex items-center justify-center gap-1.5 rounded-full py-[4px] text-[16px]
//                                    font-medium border transition-all duration-200
//                                    hover:scale-[1.02] active:scale-[0.98]"
//                         style={{ borderColor: primaryColor, color: primaryColor }}
//                     >
//                         <FaEye size={20} /> View Details
//                     </button>

//                     {showChat && (
//                         <button
//                             type="button"
//                             onClick={handleChat}
//                             className="flex items-center justify-center gap-1.5 rounded-full py-[4px] text-[16px]
//                                        font-medium border transition-all duration-200
//                                        hover:scale-[1.02] active:scale-[0.98]"
//                             style={{ borderColor: primaryColor, color: primaryColor }}
//                         >
//                             <IoChatbubbleEllipsesSharp size={20} /> Chat With Us
//                         </button>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// });

// ProductCard.displayName = 'ProductCard';

// // ─── ShopProductGridListView ──────────────────────────────────────────────────
// // (unchanged from your original — all logic stays the same)

// const ShopProductGridListView = ({ styles, products }) => {
//     const { userInfo }                    = useSelector(state => state.auth);
//     const { errorMessage, successMessage } = useSelector(state => state.cart);
//     const { seller }                      = useSelector(state => state.seller);

//     const navigate = useNavigate();
//     const dispatch = useDispatch();

//     const [modalProduct, setModalProduct] = useState(null);

//     const sellerConfig = useMemo(() => ({
//         id:               seller._id,
//         primaryColor:     seller.frontEndPrimaryColor1,
//         secondaryColor:   seller.frontEndSecondaryColor1,
//         shoppingTerm:     seller.shoppingTerm,
//         productPluralTerm: seller.productPluralTerm,
//         showPayments:     seller.isVisibleSitePayments === 'Show',
//         showWishlist:     seller.isVisibleSiteWishlist === 'Show',
//         showRating:       seller.isVisibleSiteRating   === 'Show',
//         showChat:         seller.isVisibleSiteChat     === 'Show',
//         showCuisineType:  seller.isVisibleSiteCuisineType === 'Show',
//     }), [seller]);

//     const handleAddToCart = (productId, portionSize) => {
//         if (!userInfo) { navigate('/login'); return; }
//         dispatch(add_to_cart({ userId: userInfo.id, quantity: 1, productId, portionSize }));
//     };

//     const handleAddToWishlist = (product) => {
//         if (!userInfo) { navigate('/login'); return; }
//         dispatch(add_to_wishlist({
//             userId:       userInfo.id,
//             productId:    product._id,
//             name:         product.name,
//             price:        product.price,
//             image:        product.images[0],
//             discount:     product.discount,
//             rating:       product.rating,
//             slug:         product.slug,
//             portionSizes: product.portionSizes,
//             description:  product.description,
//             byThePan:     product.byThePan,
//         }));
//     };

//     const handleChat = (chatTopic) => {
//         if (!userInfo) { navigate('/login'); return; }
//         navigate(`/customerDashboard/chat/${chatTopic}`);
//     };

//     useEffect(() => {
//         if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
//         if (errorMessage)   { toast.error(errorMessage);   dispatch(messageClear()); }
//     }, [successMessage, errorMessage, dispatch]);

//     return (
//         <div className={`w-full grid gap-3 ${
//             styles === 'grid'
//                 ? 'grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1'
//                 : 'grid-cols-1 md-lg:grid-cols-2 md:grid-cols-1'
//         }`}>
//             {products.map((p) => (
//                 <ProductCard
//                     key={p._id}
//                     product={p}
//                     styles={styles}
//                     sellerConfig={sellerConfig}
//                     onAddToCart={handleAddToCart}
//                     onAddToWishlist={handleAddToWishlist}
//                     onChat={handleChat}
//                     onQuickView={setModalProduct}
//                 />
//             ))}

//             <Modal2
//                 isOpen={!!modalProduct}
//                 onClose={() => setModalProduct(null)}
//                 product={modalProduct}
//             />
//         </div>
//     );
// };

// export default ShopProductGridListView;



// import React, { useEffect, useState, lazy, useMemo } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaEye, FaHeart } from "react-icons/fa";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { FaUser } from "react-icons/fa6";
// import { add_to_cart, add_to_wishlist, messageClear } from '../../store/reducers/cartReducer';
// import Modal2 from '../Modal2';

// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';
// import useWindowSize from '../../utils/useWindowSize';
// import SkeletonWithImage from '../SkeletonWithImage';

// const Rating = lazy(() => import('../Rating'));

// // ─── ProductCard ─────────────────────────────────────────────────────────────
// // Extracted into its own component so each card manages its own portionSize
// // state independently (prevents cross-product portion-size bleed).

// const ProductCard = React.memo(({ product: p, styles, sellerConfig, onAddToCart, onAddToWishlist, onChat, onQuickView }) => {
//     const [portionSize, setPortionSize] = useState('');
//     const navigate = useNavigate();
//     const { userInfo } = useSelector(state => state.auth);

//     const {
//         primaryColor,
//         secondaryColor,
//         shoppingTerm,
//         showPayments,
//         showWishlist,
//         showRating,
//         showChat,
//     } = sellerConfig;

//     const tooltipStyle = { color: 'white', backgroundColor: primaryColor };
//     const brandStyle = { color: primaryColor, backgroundColor: secondaryColor, borderColor: primaryColor };

//     const handleAddToCart = () => onAddToCart(p._id, portionSize);
//     const handleAddToWishlist = () => onAddToWishlist(p);
//     const handleChat = () => onChat(p.name);
//     const handleQuickView = () => onQuickView(p);
//     const handleViewDetails = () => navigate(`/product/details/${p._id}`);

//     const portionSizeOptions = p.portionSizes
//         ? p.portionSizes.split(';').filter(Boolean)
//         : [];

//     // ── Icon action button (used in the hover overlay) ──
//     const ActionIcon = ({ onClick, hidden, icon, tooltipLine1, tooltipLine2, asButton = true }) => {
//         const classes = `${hidden ? 'hidden' : ''} w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all`;
//         const content = (
//             <div className="icon-container">
//                 <span className="icon flex justify-center items-center">
//                     &nbsp;{icon}&nbsp;
//                 </span>
//                 <div className="tooltip" style={tooltipStyle}>
//                     {tooltipLine1}<br />{tooltipLine2}
//                 </div>
//             </div>
//         );
//         return asButton
//             ? <button type="button" onClick={onClick} className={classes} style={{ backgroundColor: 'white', color: primaryColor, borderColor: primaryColor }}>{content}</button>
//             : <span onClick={onClick} className={classes} style={{ backgroundColor: 'white', color: primaryColor, borderColor: primaryColor }}>{content}</span>;
//     };

//     // ── Portion size select (shared between grid & list) ──
//     const PortionSizeSelect = () =>
//         portionSizeOptions.length > 0 ? (
//             <select
//                 onChange={e => setPortionSize(e.target.value)}
//                 value={portionSize}
//                 className="border rounded-md px-3 mb-1 mt-2 w-full text-[14px] font-semibold"
//                 style={{ borderColor: primaryColor, color: primaryColor, backgroundColor: secondaryColor }}
//             >
//                 <option value="">Choose Portion Size</option>
//                 {portionSizeOptions.map((size, i) => (
//                     <option key={i} value={size}>{size}</option>
//                 ))}
//             </select>
//         ) : null;

//     // ── Add-to-cart button label ──
//     const CartButtonLabel = ({ size = 'md' }) =>
//         userInfo ? (
//             <><MdOutlineRestaurantMenu className="mr-1" /> Add To {shoppingTerm}</>
//         ) : (
//             <span className={`flex gap-0.5 ${size === 'sm' ? 'text-[13px]' : 'text-[14px]'} justify-center items-center`}>
//                 <FaUser size={15} /> Please Login Or Register
//             </span>
//         );

//     return (
//         <div
//             className={`flex border-2 transition-all duration-1000 hover:shadow-md hover:-translate-y-3
//             ${styles === 'grid'
//                 ? 'flex-col justify-start items-start'
//                 : 'justify-start items-center md-lg:flex-col md-lg:justify-start md-lg:items-start'}
//             w-full gap-1 bg-white p-0`}
//             style={brandStyle}
//         >
//             {/* ── Image + hover icons ── */}
//             <div className={styles === 'grid'
//                 ? 'w-full relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden'
//                 : 'md-lg:w-full relative group h-[210px] md:h-[270px] w-[270px] overflow-hidden'}>

//                 <div style={{ color: primaryColor, backgroundColor: secondaryColor }}>
//                     <div className="relative text-center border">
//                         <SkeletonWithImage
//                             src={p.images[0]}
//                             alt={p.name}
//                             className="h-[240px] md:h-[270px] xs:h-[170px] w-full object-cover"
//                         />
//                         {p.byThePan !== 'NoPan' && (
//                             <div
//                                 className="m-1 border w-[97%] absolute top-0 left-0 text-center"
//                                 style={brandStyle}
//                             >
//                                 {p.byThePan}
//                             </div>
//                         )}
//                     </div>

//                     <ul className="flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3">
//                         <li>
//                             <ActionIcon
//                                 onClick={handleAddToCart}
//                                 icon={<><span>+</span><MdOutlineRestaurantMenu /></>}
//                                 tooltipLine1="Add To"
//                                 tooltipLine2={shoppingTerm}
//                             />
//                         </li>
//                         <li>
//                             <ActionIcon
//                                 onClick={handleAddToWishlist}
//                                 hidden={!showWishlist}
//                                 icon={<FaHeart />}
//                                 tooltipLine1="Add To"
//                                 tooltipLine2="Wishlist"
//                             />
//                         </li>
//                         <li>
//                             {/* Quick view is a UI action, not navigation — use button not Link */}
//                             <ActionIcon
//                                 onClick={handleQuickView}
//                                 icon={<FaEye />}
//                                 tooltipLine1="Quick"
//                                 tooltipLine2="View"
//                             />
//                         </li>
//                         <li>
//                             <ActionIcon
//                                 onClick={handleChat}
//                                 hidden={!showChat}
//                                 icon={<IoChatbubbleEllipsesSharp />}
//                                 tooltipLine1="Chat"
//                                 tooltipLine2="With Us"
//                                 asButton={false}
//                             />
//                         </li>
//                     </ul>
//                 </div>
//             </div>

//             {/* ── Product info ── */}
//             <div className="align-top flex w-full justify-start items-start flex-col gap-1 p-1" style={{ color: primaryColor }}>

//                 {/* Name */}
//                 <span className={`font-bold truncate w-full ${styles === 'list' ? 'text-xl' : ''}`}>
//                     {p.name}
//                 </span>

//                 {/* Price + Rating */}
//                 <div className="flex justify-start items-center gap-3">
//                     {showPayments && (
//                         <span className="text-md font-semibold" style={{ color: primaryColor }}>
//                             {currencyFormat.format(p.price)}
//                         </span>
//                     )}
//                     {showRating && (
//                         <Rating ratings={p.rating} />
//                     )}
//                 </div>

//                 {/* ── GRID view extras ── */}
//                 {styles === 'grid' && (
//                     <div className="w-full">
//                         {portionSizeOptions.length > 0 ? (
//                             <PortionSizeSelect />
//                         ) : (
//                             <p
//                                 className="py-1 px-1 mb-1 border text-[14px] font-semibold truncate"
//                                 style={brandStyle}
//                             >
//                                 {p.description}
//                             </p>
//                         )}
//                         <button
//                             type="button"
//                             onClick={handleAddToCart}
//                             className="px-1 py-1 mb-1 h-[34px] flex w-full justify-center items-center rounded-lg text-md cursor-pointer text-white"
//                             style={{ backgroundColor: primaryColor }}
//                         >
//                             <CartButtonLabel />
//                         </button>
//                     </div>
//                 )}

//                 {/* ── LIST view extras ── */}
//                 {styles === 'list' && (
//                     <div className="w-full">
//                         <div
//                             className="w-[99%] border text-[13px] p-1 mr-1 overflow-auto"
//                             style={{ ...brandStyle, height: portionSizeOptions.length > 0 ? '50px' : '80px' }}
//                         >
//                             {p.description}
//                         </div>
//                         <PortionSizeSelect />
//                         <div className="w-full grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-1 justify-between items-center mt-1">
//                             <div className="h-[30px] w-[150px]">
//                                 <button
//                                     type="button"
//                                     onClick={handleAddToCart}
//                                     className="px-1 py-1 w-full h-full flex rounded-lg text-sm justify-center items-center cursor-pointer hover:shadow-lg hover:shadow-green-500/40 text-white"
//                                     style={{ backgroundColor: primaryColor }}
//                                 >
//                                     {userInfo
//                                         ? <><MdOutlineRestaurantMenu className="mr-1 text-[16px]" /> Add To {shoppingTerm}</>
//                                         : <><FaUser className="mr-1 text-[16px]" /> Please Login</>}
//                                 </button>
//                             </div>
//                             {showWishlist && (
//                                 <div className="h-[30px] w-[150px]">
//                                     <button
//                                         type="button"
//                                         onClick={handleAddToWishlist}
//                                         className="w-full h-full rounded-lg flex text-sm justify-center items-center cursor-pointer hover:shadow-lg hover:shadow-cyan-500/40 text-white"
//                                         style={{ backgroundColor: primaryColor }}
//                                     >
//                                         {userInfo
//                                             ? <><FaHeart className="mr-1 text-[16px]" /> Add To Wishlist</>
//                                             : <><FaUser className="mr-1 text-[16px]" /> Please Login</>}
//                                     </button>
//                                 </div>
//                             )}
//                             <div className="h-[30px] w-[150px]">
//                                 <button
//                                     type="button"
//                                     onClick={handleViewDetails}
//                                     className="px-1 py-1 w-full h-full flex rounded-lg text-sm cursor-pointer justify-center items-center hover:shadow-lg hover:shadow-green-500/40 text-white"
//                                     style={{ backgroundColor: primaryColor }}
//                                 >
//                                     <FaEye className="mr-1 text-[16px]" /> View Details
//                                 </button>
//                             </div>
//                             {showChat && (
//                                 <div className="h-[30px] w-[150px]">
//                                     <button
//                                         type="button"
//                                         onClick={handleChat}
//                                         className="px-1 py-1 w-full h-full flex rounded-lg text-sm cursor-pointer justify-center items-center hover:shadow-lg hover:shadow-green-500/40 text-white"
//                                         style={{ backgroundColor: primaryColor }}
//                                     >
//                                         <IoChatbubbleEllipsesSharp className="mr-1 text-[16px]" /> Chat With Us
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// });

// ProductCard.displayName = 'ProductCard';

// // ─── ShopProductGridListView ──────────────────────────────────────────────────

// const ShopProductGridListView = ({ styles, products }) => {
//     const { userInfo } = useSelector(state => state.auth);
//     const { errorMessage, successMessage } = useSelector(state => state.cart);
//     const { seller } = useSelector(state => state.seller);

//     const navigate = useNavigate();
//     const dispatch = useDispatch();

//     const [modalProduct, setModalProduct] = useState(null);

//     // All seller config in one memoised object — avoids re-computing on every render
//     const sellerConfig = useMemo(() => ({
//         id: seller._id,
//         primaryColor: seller.frontEndPrimaryColor1,
//         secondaryColor: seller.frontEndSecondaryColor1,
//         shoppingTerm: seller.shoppingTerm,
//         productPluralTerm: seller.productPluralTerm,
//         showPayments: seller.isVisibleSitePayments === 'Show',
//         showWishlist: seller.isVisibleSiteWishlist === 'Show',
//         showRating: seller.isVisibleSiteRating === 'Show',
//         showChat: seller.isVisibleSiteChat === 'Show',
//         showCuisineType: seller.isVisibleSiteCuisineType === 'Show',
//     }), [seller]);

//     // ── Cart / wishlist handlers ──
//     const handleAddToCart = (productId, portionSize) => {
//         if (!userInfo) { navigate('/login'); return; }
//         dispatch(add_to_cart({
//             userId: userInfo.id,
//             quantity: 1,
//             productId,
//             portionSize,
//         }));
//     };

//     const handleAddToWishlist = (product) => {
//         if (!userInfo) { navigate('/login'); return; }
//         //from claude refactor
//         // Pass the full product object; let the reducer/selector extract what it needs
//         //dispatch(add_to_wishlist({ userId: userInfo.id, product }));

//         dispatch(add_to_wishlist({
//             userId: userInfo.id,
//             productId: product._id,
//             name: product.name,
//             price: product.price,
//             image: product.images[0],
//             discount: product.discount,
//             rating: product.rating,
//             slug: product.slug,
//             portionSizes: product.portionSizes,
//             description: product.description,
//             byThePan: product.byThePan
//         }))
//     };

// //     const add_to_wishlist_local = (pro) => {
// //         if (userInfo) {
// //             dispatch(add_to_wishlist({
// //                 userId: userInfo.id,
// //                 productId: pro._id,
// //                 name: pro.name,
// //                 price: pro.price,
// //                 image: pro.images[0],
// //                 discount: pro.discount,
// //                 rating: pro.rating,
// //                 slug: pro.slug,
// //                 portionSizes: pro.portionSizes,
// //                 description: pro.description,
// //                 byThePan: pro.byThePan
// //             }))
// //         } else {
// //             navigate('/login')
// //         }
// //     }

//     const handleChat = (chatTopic) => {
//         if (!userInfo) { navigate('/login'); return; }
//         navigate(`/customerDashboard/chat/${chatTopic}`);
//     };

//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch]);

//     return (
//         <div className={`w-full grid ${styles === 'grid'
//             ? 'grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1'
//             : 'grid-cols-1 md-lg:grid-cols-2 md:grid-cols-1'} gap-3`}>

//             {products.map((p) => (
//                 // Use stable product ID as key, not array index
//                 <ProductCard
//                     key={p._id}
//                     product={p}
//                     styles={styles}
//                     sellerConfig={sellerConfig}
//                     onAddToCart={handleAddToCart}
//                     onAddToWishlist={handleAddToWishlist}
//                     onChat={handleChat}
//                     onQuickView={setModalProduct}
//                 />
//             ))}

//             <Modal2
//                 isOpen={!!modalProduct}
//                 onClose={() => setModalProduct(null)}
//                 product={modalProduct}
//             />
//         </div>
//     );
// };

// export default ShopProductGridListView;




// import React, { useEffect, useState, lazy, Fragment } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaEye, FaRegHeart, FaHeart } from "react-icons/fa";
// import { RiShoppingCartLine } from "react-icons/ri";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoMdRestaurant } from "react-icons/io";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { FaUser } from "react-icons/fa6";
// import { add_to_cart, add_to_wishlist, messageClear } from '../../store/reducers/cartReducer';
// //import Modal from '../Modal';
// import Modal2 from '../Modal2';

// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';
// import useWindowSize from '../../utils/useWindowSize';
// import SkeletonWithImage from '../SkeletonWithImage';

// const Rating  = lazy(()=> import('../Rating')) 

// const ShopProductGridListView = ({styles, products}) => {
//     const { userInfo } = useSelector(state => state.auth)
//     const { errorMessage, successMessage } = useSelector(state => state.cart)
//     const { seller } = useSelector(state => state.seller)
//     const { screenWidth, screenHeight } = useWindowSize();
//     //const [ showModal, setShowModal] = useState(false)
//     //const [ showModalID, setShowModalID] = useState(0)

//      const [modalProduct, setModalProduct] = useState(null);
//     const openModal = (product) => {
//         setModalProduct(product);
//     };
//     const closeModal = () => {
//         setModalProduct(null);
//     };

//     //const [productNameSnippet, setProductNameSnippet] = useState('')
    
//     //console.log(products)

//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
//     const sellerShoppingTerm = seller.shoppingTerm
//     const sellerProductPluralTerm = seller.productPluralTerm

//     const sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteWishList = seller.isVisibleSiteWishlist === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller.isVisibleSiteChat === 'Show' ? true : false
//     const sellerBoolShowCuisineType = seller.isVisibleSiteCuisineType === 'Show' ? true : false

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };
    
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const [portionSize, setPortionSize] = useState('')

//     let buttonTextAddToWishList =  userInfo ? 'Add To Wish List' : 'Please Login'
//     let descriptionHeight = 30
    
//     const add_to_cart_local = (id) => {
//         if (userInfo) {
//             dispatch(add_to_cart({
//                 userId: userInfo.id,
//                 quantity : 1,
//                 productId : id,// product._id,
//                 portionSize: portionSize
//             }))
//             setPortionSize('')
//         } else {
//             navigate('/login')
//         }
//     }

//     const add_to_wishlist_local = (pro) => {
//         if (userInfo) {
//             dispatch(add_to_wishlist({
//                 userId: userInfo.id,
//                 productId: pro._id,
//                 name: pro.name,
//                 price: pro.price,
//                 image: pro.images[0],
//                 discount: pro.discount,
//                 rating: pro.rating,
//                 slug: pro.slug,
//                 portionSizes: pro.portionSizes,
//                 description: pro.description,
//                 byThePan: pro.byThePan
//             }))
//         } else {
//             navigate('/login')
//         }
//     }

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
        
//         <div className={`w-full grid ${styles === 'grid' ? 
//             'grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1' : 
//             'grid-cols-1 md-lg:grid-cols-2 md:grid-cols-1'} gap-3 `}>
//             {   
//                 //md:grid-cols-2
//                 products.map((p, i)=>
                    
//                     <div key={i} 
//                         className={`flex border-2 transition-all duration-1000 hover:shadow-md hover:-translate-y-3 
//                         ${styles === 'grid' ? 
//                         'flex-col justify-start items-start' 
//                         : 
//                         'justify-start items-center md-lg:flex-col md-lg:justify-start md-lg:items-start'} 
//                         w-full gap-1 bg-white p-1`}
//                         style={{color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}>
                        
//                         <div className={styles === 'grid' ? 
//                             'w-full relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden' 
//                             : 
//                             'md-lg:w-full relative group h-[210px] md:h-[270px] w-[270px] overflow-hidden'}>
//                             {
//                                 // product={p} parentPage={'ShopProducts'} descriptionSubstringLength={36}
//                                 //w-[240px] md:w-[270px] xs:w-[170px]
//                                 // style={{color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}
//                             }
                            
//                             <div id='ImageAndIcons' className='' style={{color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}} >
//                                 <div className="relative text-center border" >
//                                     <SkeletonWithImage src={p.images[0]} alt="" className='h-[240px] md:h-[270px] xs:h-[170px] w-full object-cover' />
//                                     <div className={` ${p.byThePan === 'NoPan' ? 'hidden' : ''} m-1 border w-[97%] absolute top-0 left-0 text-center`}
//                                         style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         {p.byThePan}
//                                     </div>
//                                 </div>

//                                 { /* <img className='sm:w-full w-full h-[240px]' src={p.images[0]} alt="" /> */ }

//                                 <ul className={`flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3`}>
//                                     {/*  hover:bg-[#059473] hover:text-white hover:rotate-[720deg] */}
//                                     <li onClick={() => add_to_cart_local(p._id)} 
//                                         className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
//                                         style={{ backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className="icon-container">
//                                             <span className='icon flex justify-center items-center'>
//                                                 +<MdOutlineRestaurantMenu />&nbsp;
//                                             </span>
//                                             <div className="tooltip" style={tooltipHoverStyle}>Add To<br />{sellerShoppingTerm}</div>
//                                         </div>
//                                     </li>
//                                     <li onClick={() => add_to_wishlist_local(p)}
//                                         className={` ${sellerBoolShowSiteWishList ? '' : 'hidden'} 
//                                         w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all`}
//                                         style={{ backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className="icon-container">
//                                             <span className='icon flex justify-center items-center'>
//                                                 &nbsp;<FaHeart />&nbsp;
//                                             </span>
//                                             <div className="tooltip" style={tooltipHoverStyle}>Add To<br />Wishlist</div>
//                                         </div>
//                                     </li>
//                                     <Link onClick={() => openModal(p)}
//                                         className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                         style={{ backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className="icon-container">
//                                             <span className='icon flex justify-center items-center'>
//                                                 &nbsp;<FaEye />&nbsp;
//                                             </span>
//                                             <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                                         </div>
//                                     </Link>
//                                     {
//                                         //onClick={() => setShowModalID(p._id)}
//                                         // to={`/product/details/${p._id}`}
//                                         // flex     
//                                     }   
//                                     <Link  
//                                         className={`hidden w-[38px] h-[38px] cursor-pointer justify-center items-center rounded-full 
//                                         hover:rotate-[720deg] transition-all bg-white hover:bg-[#059473] hover:text-white`}>
//                                         <FaEye />M
//                                     </Link>
                                    
//                                     {/*onClick={redirect_chat_page}*/}
//                                     <span onClick={() => redirect_chat_page(p.name)}  
//                                         className={` ${sellerBoolShowSiteChat ? '' : 'hidden'} 
//                                         w-[38px] h-[38px] cursor-pointer bg-white border flex justify-center items-center rounded-full transition-all` }
//                                         style={{ backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className="icon-container">
//                                             <span className='icon flex justify-center items-center'>
//                                                 &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                             </span>
//                                             <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                         </div>
//                                     </span>
//                                 </ul>


//                             </div>
//                         </div>
//                         <div className='align-top flex w-full justify-start items-start flex-col gap-1 p-1' style={{color:sellerPrimaryColor1}}>
//                             <div className={` ${styles === 'grid' ? 'hidden font-bold' : 'hidden'} `}>
//                                 { p.name.length > 26 ? p.name.substring(0, 26) + ' ...' : p.name }
//                             </div>
//                             <div className={` ${styles === 'grid' ? 'font-bold' : 'hidden'} `}>
//                                 <div className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                     <span className='font-bold'>{p.name}</span>
//                                 </div>
//                                 <div className='sm:hidden'>
//                                     <span>{p.name?.substring(0, parseInt(screenWidth / 52))}</span>
//                                     <span className={` ${(p.name?.substring(0, parseInt(screenWidth / 52))?.length >= p.name?.length) ? 'hidden' : '' } `}> ...</span>
//                                 </div>
//                             </div>
//                             <span className={` ${styles === 'list' ? 'text-xl font-bold' : 'hidden'} `}>
//                                 {p.name}
//                             </span>
//                             <div className={`flex justify-start items-center gap-3`}>
//                                 <span className={`${sellerBoolShowSitePayments ? '' : 'hidden'} text-md font-semibold`} style={{color:sellerPrimaryColor1}} >
//                                     {currencyFormat.format(p.price)}
//                                 </span>
//                                 <span className={` ${sellerBoolShowSiteRating ? 'flex' : 'hidden'} `}>
//                                     <Rating ratings={p.rating} />
//                                 </span>
//                             </div>
//                             <div className={` ${styles === 'grid' ? 'w-full' : 'hidden'} `} >
//                                 <div className={`${p.portionSizes !== '' ? 'w-full' : 'hidden'} `}>
//                                     <select onChange={(e) => setPortionSize(e.target.value)} id='' name='' 
//                                         className='border rounded-md px-3 mb-1 mt-2 w-full text-[14px] font-semibold' 
//                                         style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                         <option value=''>Choose Portion Size</option>
//                                         {
//                                             p.portionSizes.split(';').map((p,i) => {
//                                                 return( <option key={i} value={p}>{p}</option> )
//                                             })
//                                         }
//                                     </select>
//                                 </div>
//                                 <div>
//                                     <div className={`${p.portionSizes === '' ? '' : 'hidden'} py-1 px-1 mb-1 border text-[14px] font-semibold`}
//                                         style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                         <div className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                             <span>{p.description?.substring(0, parseInt(screenWidth / 10))}</span> ...
//                                         </div>
//                                         <div className='sm:hidden'>
//                                             <span>{p.description?.substring(0, parseInt(screenWidth / 52))}</span> ...
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className='w-full' >            
//                                     <button onClick={() => add_to_cart_local(p._id)} 
//                                         className='px-1 py-1 mb-1 h-[34px] flex w-full justify-center items-center rounded-lg text-md 
//                                         cursor-pointer text-white' 
//                                         style={{backgroundColor:sellerPrimaryColor1}}>
//                                         {
//                                             userInfo ? 
//                                             <><MdOutlineRestaurantMenu className='mr-1' /> Add To {sellerShoppingTerm}</>
//                                             : 
//                                             <span className='flex gap-0.5 text-[14px] justify-center items-center'>
//                                                 <FaUser size={15} /> Please Login Or Register
//                                             </span>
//                                         }
//                                     </button>     
//                                 </div>
//                             </div>
//                             <div className={` ${styles === 'list' ? 'h-[146px]' : 'hidden'} `}>
//                                 <div className='hidden' >
//                                 {
//                                     descriptionHeight = p.portionSizes !== '' ? 50 : 80
//                                 }
//                                 {
//                                     descriptionHeight += !sellerBoolShowSitePayments && !sellerBoolShowSiteRating ? 20 : 0
//                                 }
//                                 </div>
//                                 <div className='w-[99%] border text-[13px] p-1 mr-1 overflow-auto'
//                                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, 
//                                         backgroundColor:sellerSecondaryColor1, height: descriptionHeight + 'px'}}>
//                                         {p.description}
//                                 </div>
//                                 <div className={`${p.portionSizes !== '' ? 'w-full' : 'hidden'} `}>
//                                     <select onChange={(e) => setPortionSize(e.target.value)} id='' name='' 
//                                         className='border rounded-md px-3 mt-1 w-[180px] text-[14px] font-semibold' 
//                                         style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                         <option value=''>Choose Portion Size</option>
//                                         {
//                                             p.portionSizes.split(';').map((p,i) => {
//                                                 return( <option key={i} value={p}>{p}</option> )
//                                             })
//                                         }
//                                     </select>
//                                 </div>
//                                 {
//                                     //className='pl-2 w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2'
//                                     //className='flex flex-col-4 gap-2 mt-1 mb-1 '
//                                 }
//                                 <div className='w-full grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-1 justify-between items-center'>
//                                     <div className='h-[30px] w-[150px] mt-1'>  
//                                         <button onClick={() => add_to_cart_local(p._id)} 
//                                             className='px-1 py-1 w-full h-full flex rounded-lg text-sm justify-center items-center cursor-pointer 
//                                             hover:shadow-lg hover:shadow-green-500/40 bg-[#059473] text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}> 
//                                             {
//                                                 userInfo ? 
//                                                 <><MdOutlineRestaurantMenu className='mt-1 ml-1 mr-1 text-[16px]' /> Add To {sellerShoppingTerm}</>
//                                                 : 
//                                                 <><FaUser className=' ml-1 mr-1 text-[16px]' /> Please Login</>
//                                             }
//                                         </button>
//                                     </div>
//                                     <div className='h-[30px] w-[150px]'>
//                                         <button onClick={() => add_to_wishlist_local(p)} 
//                                             className={` ${sellerBoolShowSiteWishList ? '' : 'hidden'}  
//                                             w-full h-full rounded-lg flex text-sm justify-center items-center  
//                                             cursor-pointer hover:shadow-lg hover:shadow-cyan-500/40 text-white`}
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             {
//                                                 userInfo ? 
//                                                 <><FaHeart className='mt-1 ml-1 mr-1 text-[16px]' /> Add To Wishlist</>
//                                                 : 
//                                                 <><FaUser className=' ml-1 mr-1 text-[16px]' /> Please Login</>
//                                             }
//                                         </button>
//                                     </div>
//                                     <div className='h-[30px] w-[150px]'>
//                                         <button onClick={() => navigate(`/product/details/${p._id}`)} 
//                                             className='px-1 py-1 w-full h-full flex rounded-lg text-sm cursor-pointer 
//                                             hover:shadow-lg  justify-center items-center 
//                                             hover:shadow-green-500/40 bg-[#059473] text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <FaEye className='mr-1 ml-1 mt-1 text-[16px]' /> View Details
//                                         </button>
//                                     </div>
//                                     <div className='h-[30px] w-[150px]'>
//                                         <button onClick={() => redirect_chat_page(p.name)}
//                                             className={` ${sellerBoolShowSiteChat ? '' : 'hidden'} 
//                                             px-1 py-1 w-full h-full flex rounded-lg text-sm cursor-pointer justify-center items-center hover:shadow-lg 
//                                             hover:shadow-green-500/40 bg-[#059473] text-white`} 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <IoChatbubbleEllipsesSharp className='mt-1 mr-1 ml-1 text-[16px]' /> Chat With Us
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         {
//                         /*
//                          <Modal id={'modalProductDetailsPopup' + p._id} isVisible={showModalID === p._id} 
//                             onClose={() => setShowModalID(0)}>
//                             <div className='text-lg font-semibold' style={{color:sellerPrimaryColor1}} >{p.name}</div>
//                             <div className='grid grid-cols-2 gap-2 justify-between items-center'>
//                                 <div>
//                                     {
//                                         //style={{width:imageWidth, height:ImageHeight}}
//                                     }
//                                     <img className={`sm:w-full object-cover `}  src={p.images[0]} alt="" />     
//                                 </div>
//                                 <div>
//                                     {
//                                     //height:ImageHeight,
//                                     }
//                                     <textarea required name="" id="" 
//                                         className='border outline-0 w-full' 
//                                         style={{color:sellerPrimaryColor1,  backgroundColor:sellerSecondaryColor1}}
//                                         value={p.description} />
//                                 </div>
//                             </div>
//                         </Modal>
//                         */
//                         }   
//                     </div>
//                 )
//             }
//             <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />   
//         </div>
//     );
// };

// export default ShopProductGridListView;




/*
<Modal isVisible={showModal} onClose={() => setShowModalID(0)}>
    <div className='text-lg font-semibold' style={{color:sellerPrimaryColor1}} >{p.name}</div>
    <div className='grid grid-cols-2 gap-2 justify-between items-center'>
        <div>
            {
                //style={{width:imageWidth, height:ImageHeight}}
            }
            <img className={`sm:w-full object-cover `}  src={p.images[0]} alt="" />     
        </div>
        <div>
            {
            //height:ImageHeight,
            }
            <textarea required name="" id="" 
                className='border outline-0 w-full' 
                style={{color:sellerPrimaryColor1,  backgroundColor:sellerSecondaryColor1}}
                value={p.description} />
        </div>
    </div>
</Modal>

*/